@if (event && (showCountdown || isHappeningNow || (eventEnded && viewingEventPage))) {
  @if (heroMode) {
    <div class="fui-featured-video">
      <div class="fui-featured-video-media" aria-hidden="true">
        @if (event.image_url) {
          <img [src]="event.image_url" class="fui-featured-video-iframe" style="object-fit: cover; width: 100%; height: 100%; position: absolute; top: 0; left: 0" />
        }
        <div class="fui-featured-video-overlay" style="display: flex; align-items: flex-end; justify-content: center">
          <div
            class="fui-featured-video-overlay-content"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              text-align: center;
              width: 100%;
              padding: 40px 20px;
              backdrop-filter: blur(12px);
              -webkit-backdrop-filter: blur(12px);
              background: rgba(0, 0, 0, 0.4);
            "
          >
            @if (showCountdown) {
              <div class="event-countdown__label">{{ "events.upcoming_livestream" | translate }}</div>
              <h2 class="fui-heading-font m-t-10 t-30">{{ event.title }}</h2>
              <div class="event-countdown__timer m-t-20" style="display: flex; align-items: center; gap: 10px">
                @if (countdownDays > 0) {
                  <div class="event-countdown__unit" style="text-align: center">
                    <div class="fui-heading-font" style="font-size: 2.5rem">{{ countdownDays }}</div>
                    <div style="font-size: 0.75rem; opacity: 0.7">{{ "events.days" | translate }}</div>
                  </div>
                  <div class="fui-heading-font" style="font-size: 2.5rem">:</div>
                }
                <div class="event-countdown__unit" style="text-align: center">
                  <div class="fui-heading-font" style="font-size: 2.5rem">{{ countdownHours | number: "2.0-0" }}</div>
                  <div style="font-size: 0.75rem; opacity: 0.7">{{ "events.hours" | translate }}</div>
                </div>
                <div class="fui-heading-font" style="font-size: 2.5rem">:</div>
                <div class="event-countdown__unit" style="text-align: center">
                  <div class="fui-heading-font" style="font-size: 2.5rem">{{ countdownMinutes | number: "2.0-0" }}</div>
                  <div style="font-size: 0.75rem; opacity: 0.7">{{ "events.minutes" | translate }}</div>
                </div>
                <div class="fui-heading-font" style="font-size: 2.5rem">:</div>
                <div class="event-countdown__unit" style="text-align: center">
                  <div class="fui-heading-font" style="font-size: 2.5rem">{{ countdownSeconds | number: "2.0-0" }}</div>
                  <div style="font-size: 0.75rem; opacity: 0.7">{{ "events.seconds" | translate }}</div>
                </div>
              </div>
            }
            @if (isHappeningNow) {
              @if (viewingEventPage) {
                <div class="event-countdown__happening-now-label" style="font-size: 2rem">{{ "events.happening_now" | translate }}</div>
              } @else {
                <div class="event-countdown__label" style="font-size: 2rem">{{ "events.happening_now" | translate }}</div>
                <h2 class="fui-heading-font m-t-10 t-30">{{ event.title }}</h2>
              }
            }
            @if (requiresUpgrade) {
              <button class="btn btn-primary m-t-20" (click)="upgrade()">{{ "events.subscribe_to_watch" | translate }}</button>
            } @else {
              <button class="btn btn-primary m-t-20" (click)="openLivestream()">
                <fa-icon icon="play" class="m-r-10"></fa-icon>
                {{ "home.launch_livestream" | translate }}
              </button>
              @if (event?.preview_video_id && !isHappeningNow) {
                <button class="btn btn-secondary m-t-20 m-l-10" (click)="openLivestream(true)">{{ "events.watch_trailer" | translate }}</button>
              }
            }
            @if (!viewingEventPage) {
              <br />
              <a [routerLink]="['/events/' + event.slug]" class="btn btn-blank">{{ "events.view_event_details" | translate }}</a>
            }
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="event-countdown" style="text-align: center">
      @if (showCountdown) {
        <div class="event-countdown__label">{{ "events.upcoming_livestream" | translate }}</div>
        @if (!viewingEventPage) {
          <h2 class="fui-heading-font m-t-10 t-30">{{ event.title }}</h2>
        }
        <div class="event-countdown__timer m-t-15" style="display: flex; align-items: center; justify-content: center">
          @if (countdownDays > 0) {
            <div class="event-countdown__unit">
              <div class="event-countdown__value">{{ countdownDays }}</div>
              <div class="event-countdown__name">{{ "events.days" | translate }}</div>
            </div>
            <div class="event-countdown__separator">:</div>
          }
          <div class="event-countdown__unit">
            <div class="event-countdown__value">{{ countdownHours | number: "2.0-0" }}</div>
            <div class="event-countdown__name">{{ "events.hours" | translate }}</div>
          </div>
          <div class="event-countdown__separator">:</div>
          <div class="event-countdown__unit">
            <div class="event-countdown__value">{{ countdownMinutes | number: "2.0-0" }}</div>
            <div class="event-countdown__name">{{ "events.minutes" | translate }}</div>
          </div>
          <div class="event-countdown__separator">:</div>
          <div class="event-countdown__unit">
            <div class="event-countdown__value">{{ countdownSeconds | number: "2.0-0" }}</div>
            <div class="event-countdown__name">{{ "events.seconds" | translate }}</div>
          </div>
        </div>
      }
      @if (isHappeningNow) {
        @if (viewingEventPage) {
          <div class="event-countdown__happening-now-label">{{ "events.happening_now" | translate }}</div>
        } @else {
          <div class="event-countdown__label">{{ "events.happening_now" | translate }}</div>
          <h2 class="fui-heading-font m-t-10 t-30">{{ event.title }}</h2>
        }
      }
      @if (eventEnded) {
        <div class="event-countdown__label">Event ended on {{ event.end_datetime | date }}</div>
        <button class="btn btn-primary m-t-15" (click)="openLivestream()">
          <fa-icon icon="play" class="m-r-10"></fa-icon>
          Watch Livestream
        </button>
      }
      @if (requiresUpgrade) {
        <button class="btn btn-primary m-t-15" (click)="upgrade()">{{ "events.subscribe_to_watch" | translate }}</button>
      } @else if (!eventEnded) {
        <button class="btn btn-primary m-t-15" (click)="openLivestream()">
          <fa-icon icon="play" class="m-r-10"></fa-icon>
          {{ "home.launch_livestream" | translate }}
        </button>
        @if (event?.preview_video_id && !isHappeningNow) {
          <button class="btn btn-secondary m-t-15 m-l-10" (click)="openLivestream(true)">{{ "events.watch_trailer" | translate }}</button>
        }
      }
      @if (!viewingEventPage) {
        <br />
        <a [routerLink]="['/events/' + event.slug]" class="btn btn-blank m-t-20">{{ "events.view_event_details" | translate }}</a>
      }
    </div>
  }
}
